export function validateToken(): Boolean {
  const local = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);

  if (local) {
    const parse = JSON.parse(local);

    if (Date.now() < parse.date + (60 * 1000 * 60)){
      return true;
    }else{
      localStorage.clear();
    }

  };

  return false
}

export function takeToken(): string {
  const place = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
  if(place){
    const { token } = JSON.parse(place ?? '');
    return token
  }
  return ''
}

export function takeNameUser(): String {
  const place = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`) ?? '';
  const { nome } = JSON.parse(place);
  return nome;
}

export function takeRotinas(): Array<any> {
  const place = localStorage.getItem('permissoes') ?? '';

  if(place){
    const rotinas = JSON.parse(place)
    return rotinas;
  }
  return [];
}

export function createCache(data: any) {
  localStorage.setItem(`cache`, data);
}

export function defineToken(data: {token: String, nome:String, id: String, permissoes: Array<any>}): void {
  const objectAuth = JSON.stringify({
    token: data.token,
    nome: data.nome,
    id: data.id,
    date: Date.now()
  });
  localStorage.setItem(`${process.env.REACT_APP_LOCAL_TOKEN}`, objectAuth);
}

export function clearToken(): void {
  localStorage.clear();
}

export function DefineRotinas(data: Array<any>): void {
  localStorage.setItem(`permissoes`, JSON.stringify(data));
}
